export const RecruitmentRequest = {
    path: '/recruitment_requests',
    name: 'recruitment_requests',
    component: () => import('@/views/Request/RecruitmentRequest/RecruitmentRequestPage.vue'),
    children: [
        {
            path: '/recruitment_requests/add',
            name: 'recruitment_requests.add',
            component: () => import('@/views/Request/RecruitmentRequest/Form/RecruitmentRequestForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/recruitment_requests/edit/:id',
            name: 'recruitment_requests.edit',
            component: () => import('@/views/Request/RecruitmentRequest/Form/RecruitmentRequestForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/recruitment_requests/delete/:id',
            name: 'recruitment_requests.delete',
            component: () => import('@/views/Request/RecruitmentRequest/Form/RecruitmentRequestForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/recruitment_requests/view/:id',
            name: 'recruitment_requests.view',
            component: () => import('@/views/Request/RecruitmentRequest/Form/RecruitmentRequestForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/recruitment_requests/start_sourcing/:id',
            name: 'recruitment_requests.start_sourcing',
            component: () => import('@/views/Request/RecruitmentRequest/Form/StartSourcingForm.vue'),
        },
        {
            path: '/recruitment_requests/filter/:id',
            name: 'recruitment_requests.filter',
            component: () => import('@/views/Request/RecruitmentRequest/Form/RecruitmentRequestFilteringForm.vue'),
        },
        {
            path: '/recruitment_requests/set_decision/:id/:module',
            name: 'recruitment_requests.set_decision',
            component: () => import('@/views/Request/Components/SetDecision.vue'),
        },
        {
            path: '/recruitment_requests/take_in_charge/:id/:module',
            name: 'recruitment_requests.take_in_charge',
            component: () => import('@/views/Request/Components/TakeInCharge.vue'),
        },
        {
            path: '/recruitment_requests/timelines/:id/:module',
            name: 'recruitment_requests.timelines',
            component: () => import('@/views/Request/Components/ValidationTimelines.vue'),
        },
        {
            path: '/recruitment_requests/documents/:id',
            name: 'recruitment_requests.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "RECRUITMENT_REQUEST"}
        },
        {
            path: '/recruitment_requests/template_applications/:id',
            name: 'recruitment_requests.template_applications',
            component: () => import('@/views/Edms/TemplateApplication/ModuleTemplateApplicationPage.vue'),
            props: {module: "RECRUITMENT_REQUEST"}
        },
    ],
}